import React, { useState, useEffect,  useMemo } from "react";
import { useHistory } from "react-router-dom";
import "./styles.css";
import { useLocation } from "react-router-dom";
import { rsaEnc } from "../../comman/decodeEncodeData";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loginUser, loginRapidUser } from "../../action/login";
import { sessonLoginUser } from "../../action/sessonLogin";
import { loginEncUser } from "../../action/loginEnc";
import { updateLocation } from "../../action/updateLocation";
import { Modal } from "react-bootstrap";


import { getCallDetails, getCustomerAddress } from "../../action/azureCalling";
import {
  _getStorageValueRapid,
} from "../../comman/localStorage";
import { findNetworkBandwidth } from "../../comman/checkinternetbandwidth";

const getNetworkQuality = (speed) => {
  if (speed >= 300) {
    return { label: "Good", color: "green" };
  } else {
    return { label: "Bad", color: "red" };
  }
};

const RapidWeb = (props) => {
  const history = useHistory();
  const search = useLocation().search;
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [rsaLoader, setRsaLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loginSuccessState, setLoginSuccessState] = useState(false);
  const [isMediaPermissionDenied, setIsMediaPermissionDenied] = useState(false);
  const [isLocationDenied, setIsLocationDenied] = useState(false);
  const [azure, setAzure] = useState(false);
  const [show, setShow] = useState(false);
  const [isSafari, setSafari] = useState(false);
  const [isConnected, setConnected] = useState(false);
  const [permissions, setPermissions] = useState([{ label: "Signal Strength", permission: "" }, { label: "Camera", permission: "" }, { label: "Location", permission: "" }, { label: "Mic", permission: "" }, { label: "Speaker", permission: "" }]);
  const [isBrowser, setIsBrowser] = useState(false);
  const [timer, setTimer] = useState(20);
  const [isSpeakerModalOpen, setSpeakerModal] = useState(false);
  const [address, setAddress] = useState("");
  const [geoPosition, setGeoPosition] = useState("");
  const [internetSpeed, setInternetSpeed] = useState(0);

  let isAudioUnlocked = false;

const unlockAudio = () => {
  if (isAudioUnlocked) return;

  const audio = document.getElementById("myAudio");
  audio.play()
    .then(() => {
      isAudioUnlocked = true;
      audio.pause(); // Pause immediately if you don't want it to actually play
      audio.currentTime = 0;
    })
    .catch((e) => {
      console.log("Safari autoplay unlock failed", e);
    });
};

useEffect(() => {
  document.body.addEventListener('click', unlockAudio, { once: true });
  return () => {
    document.body.removeEventListener('click', unlockAudio);
  }
},[])

  const successCallBackLoginEnc = (response) => {
    setRsaLoader(false);
    loginCallRsa(response.data.rsa);
    if (response.data.rsa) {
      triggerLogin(response.data.rsa);
    }
  };

  const loginCallRsa = (key) => {
    let url = window.location.href;

    let data = url.replace(/=/g, " =");
    let datatype = data.replace(/&/g, " =");
    let fields = datatype.split("=");
  };
  const triggerLogin = (rsaKey) => {
    if (username === "") {
      setLoginSuccessState(false);
    } else if (password === "") {
      setLoginSuccessState(false);
    } else {
      props.loginRapidUser(
        rsaEnc(username, rsaKey),
        rsaEnc(password, rsaKey),
        successLogin,
        failedLogin,
      );
    }
  };

  const successLogin = (response) => {
    setLoginSuccessState(true);
    setLoading(false);
  };
  const failedLogin = () => {
    setLoading(false);
  };


  const enableContinueButton = useMemo(() => {
    return permissions
      .filter((permission) => permission.label !== "Signal Strength")
      .every((permission) => permission.permission === true);
  }, [permissions]);

  const enableDisableButton = useMemo(() => {
    return permissions
      .filter((permission) => permission.label !== "Signal Strength")
      .some((permission) => permission.permission === false);
  }, [permissions]);


  useEffect(() => {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1) {
        setSafari(false);
      } else {
        setSafari(true);
      }
    }
    const isAzure = new URLSearchParams(search).get("azureVideoCall");
    if (!!isAzure && !!props?.callDataValue?.[0]?.call_status) {
      window.location.reload();
    } else if (!!isAzure) {
      setAzure(true);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    setUserName(new URLSearchParams(search).get("username"));
    setPassword(new URLSearchParams(search).get("password"));
    if (username !== "" && password !== "") {
      props.loginEncUser(successCallBackLoginEnc);
    }
  }, [username]);

  useEffect(() => {
    if (isLocationDenied || isMediaPermissionDenied) {
      setShow(true);
    }
  }, [isLocationDenied, isMediaPermissionDenied]);


  const getUserLocation = (successCallback, failureCallback) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setPermissions(previousState => previousState.map(p =>
          p.label === "Location" ? { ...p, permission: true } : p
        ));
        successCallback(position.coords.latitude, position.coords.longitude);
      },
      (error) => {
        setPermissions(previousState => previousState.map(p =>
          p.label === "Location" ? { ...p, permission: false } : p
        ));
        // setTimeout(() => getUserLocation(successCallback, failureCallback), 2000);
        checkMicPermission();
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  // 2. Get address from lat/lon (reverse geocode) with retry
  const getAddressFromLatLon = (userID, lat, lon, successCallback, failureCallback) => {
    props.getCustomerAddress(
      userID,
      lat,
      lon,
      (data) => {
        if (data && data.data) {
          successCallback(data.data, lat, lon);
          setAddress(data.data);
        } else {
          setTimeout(() => getAddressFromLatLon(userID, lat, lon, successCallback, failureCallback), 2000);
        }
      },
      (error) => {
        setTimeout(() => getAddressFromLatLon(userID, lat, lon, successCallback, failureCallback), 2000);
      }
    );
  };

  // 3. Create call with retry
  const createCall = (userID, userName, address, lat, lon, successCallback, failureCallback) => {
    props.getCallDetails(
      userID,
      userName,
      (response) => {
        if (
          response &&
          response.data &&
          response.data[0].call_status !== "Call has not been created"
        ) {
          console.log("Call created successfully", response);
          successCallback(response);
        } else {
          setTimeout(() => createCall(userID, userName, address, lat, lon, successCallback, failureCallback), 2000);
        }
      },
      (error) => {
        setTimeout(() => createCall(userID, userName, address, lat, lon, successCallback, failureCallback), 2000);
      }
    );
  };


  const updateLocation= (userID, userName, lat, lon, successCallback ) => {
    props.updateLocation(
      userID,
      userName,
      lat,
      lon,
      (response) => {
        if (response && response.data && response.data.status === "Location updated") {
          successCallback(response);
        } else {
          updateLocation(userID, userName, lat, lon,successCallback);
        }
      },
      () => {
        setTimeout(() => updateLocation(userID, userName, lat, lon,successCallback), 2000);
      }
    );
  }


  const checkLocationPermission = () => {
    setTimeout(() => {
      _getStorageValueRapid("USER_ID_RAPID").then((userID) => {
        _getStorageValueRapid("USER_NAME").then((userName) => {
          getUserLocation(
            (lat, lon) => {
              updateLocation(userID, userName, lat, lon, () => {
              getAddressFromLatLon(userID, lat, lon, (address) => {
                createCall(userID, userName, address, lat, lon, (response) => {
                  checkMicPermission();
                }, () => {});
              }, () => {});
            }, () => {
            });
            },
            () => {}
          );
        });
      });
    },1000)
  };

  const checkinternet = async () => {
    if (isConnected) {
      console.log("Connected to the video call");
      setLoading(true);
      let test = await findNetworkBandwidth(10);
      setInternetSpeed(test);

      let updatePermissions = permissions.map((data) => {
        if (data.label === "Signal Strength") {
          return { ...data, permission: true }
        } else {
          return data;
        }
      });
      console.log("updatePermissions", updatePermissions);
      setPermissions(updatePermissions)
      setTimeout(() => {
        checkCameraPermission();
      }, 1000);
    }
  }

  const checkCameraPermission = async () => {
    const localVideo = document.getElementById('localVideo');
    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        localVideo.srcObject = stream;
        localVideo.muted = true;
        localVideo.play();
        setPermissions((previousState) => {
          let updatePermissions = previousState.map((data) => {
            if (data.label === "Camera") {
              return { ...data, permission: true }
            } else {
              return data;
            }
          });
          return updatePermissions;
        });
        // stream.getTracks().forEach(track => track.stop());
        // 
        checkLocationPermission();
      
      })
      .catch((error) => {
        console.error('Error accessing media devices.', error);
        checkLocationPermission();
        setPermissions((previousState) => {
          let updatePermissions = previousState.map((data) => {
            if (data.label === "Camera") {
              return { ...data, permission: false }
            } else {
              return data;
            }
          });
          return updatePermissions;
        });

      });
  }

  const checkSpeakerPermission = () => {
    setSpeakerModal(true);
    const audio = document.getElementById("myAudio");
    audio.loop = true;
    audio.play();
  }

  const checkMicPermission = async () => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((micStream) => {
        setPermissions((previousState) => {
          
          let updatePermissions = previousState.map((data) => {
            if (data.label === "Mic") {
              return { ...data, permission: true }
            } else {
              return data;
            }
          });
          return updatePermissions;
        })
        micStream.getTracks().forEach(track => track.stop());
        checkSpeakerPermission();
      })
      .catch((error) => {
        console.error('Error accessing media devices.', error);

        setPermissions((previousState) => {
          let updatePermissions = previousState.map((data) => {
            if (data.label === "Mic") {
              return { ...data, permission: false }
            } else {
              return data;
            }
          });
          return updatePermissions;
        })
        checkSpeakerPermission();
      });
  }



  useEffect(() => {
    if (isConnected) {
      checkinternet();
    }
  }, [isConnected]);


  useEffect(() => {
    if (timer === 0) {
      history.push("/azure-video");
    }
    if (timer > 0 && isBrowser) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer, isBrowser]);


  console.log("permissions", permissions)

  const acceptSpeakerPermission = (option) => {
    const audio = document.getElementById("myAudio");
    audio.pause();
    setPermissions((previousState) => {
      let updatePermissions = previousState.map((data) => {
        if (data.label === "Speaker") {
          return { ...data, permission: option }
        } else {
          return data;
        }
      });
      return updatePermissions;
    })
    setSpeakerModal(false);
  }

  // console.log("enableDisableButton", enableDisableButton)

  return (
    <>
      <div className="main-home-container">
        <div className="rapid-header">
          <label>ICICI - RAPID</label>
        </div>
        <a href="chrome://settings/content" target="_blank"></a>
        {loginSuccessState || azure ? (
          <React.Fragment>
            <div className={!isConnected && "sub-home-container"}>
              {!isConnected ? (<> <div className="card-videoCall" onClick={() => setConnected(true)}>
                <div className="image-png">
                  <img
                    src={require("../../assets/images/video-camera.png")}
                    alt="dsd"
                  />
                </div>
                <p className="button-text">Connect</p>
              </div>

                <div
                  style={{
                    marginTop: 30,
                    textDecoration: "underline",
                    textAlign: "center",
                    color: "blue",
                  }}
                  onClick={() => {
                    let url = window.location.href.replace("https", "rapid");
                    window.open(url);
                  }}
                >
                  Login with App
                </div>

              </>) : (
                <>
                  {!isBrowser && <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="w-50 mt-20 relative" style={{ height: 250 }}>
                      <video
                        autoPlay
                        playsInline
                        muted
                        id="localVideo"
                        controls={false}
                        style={{
                          backgroundColor: "#1c1c1c",
                        }}
                        className={
                          "rounded-[10px] h-full w-100 object-cover flex items-center justify-center flip"
                        }
                      />
                    </div>
                    {!!address && <div className="w-50 relative bg-red-600 text-black rounded-2xl shadow-md p-4 text-center font-semibold" style={{ height: "auto" }}>
                      {address}
                    </div>}
                    <div className="d-flex w-50  flex-column align-items-center justify-content-center mt-3">
                      {permissions.map((permission, index) => {
                        if (permission.label === "Signal Strength") {
                          console.log("checks",permission.permission)
                          return (
                            <div key={index} style={{ justifyContent: "space-between" }} className="d-flex w-100 flex-row align-items-center">
                              <div className="permission-item">{permission.label}</div>
                              {permission.permission === '' ? (
                                <div className="loader-circle-v1"></div>
                              ) : (
                                <div style={{ marginLeft: 10, fontSize: 14, color: '#333', display: 'grid', alignItems: 'center' }}>
                                  {internetSpeed} Kbps{' '}
                                  <span style={{
                                    color: getNetworkQuality (internetSpeed).color,
                                    marginLeft: 8,
                                    fontWeight: 600
                                  }}>
                                    (  {getNetworkQuality (internetSpeed).label} )
                                  </span>
                                </div>
                              )}
                            </div>
                          );
                        }
                        return (
                          <div key={index} style={{ justifyContent: "space-between" }} className="d-flex w-100 flex-row  align-items-center">
                            <div className="permission-item">
                              {permission.label}
                            </div>
                            {permission.permission === "" ? <div className="loader-circle-v1"> </div> : permission.permission === false ? <div>&#10060;</div> : <div> &#9989;</div>}
                          </div>
                        );
                      })}
                    </div>
                    <audio id="myAudio" src={require("../../assets/audio/music.mp3")} loop></audio>

                    <Modal style={{ marginTop: 80 }} className="desktop" show={isSpeakerModalOpen} onHide={() => setShow(false)}>
                      <Modal.Header closeButton>
                        <Modal.Title>Speaker Status</Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={{ height: "auto", padding: "10px", display: "flex", alignItems: "center" }}>
                        Need to check if speaker is working properly. If you can hear the noise clearly then press 'Yes', or else press 'No'.
                      </Modal.Body>
                      <Modal.Footer>
                        <div class="flex space-x-4">
                          <button onClick={() => {
                            acceptSpeakerPermission(true);
                          }} style={{ background: "green" }} class="bg-green-600 text-white px-5 py-2 rounded-md hover:bg-green-700">
                            Yes
                          </button>
                          <button onClick={() => {
                            acceptSpeakerPermission(false);
                          }} style={{ background: "red" }} class="bg-red-600 text-white px-5 py-2 rounded-md hover:bg-red-700">

                            No
                          </button>

                        </div>
                      </Modal.Footer>
                    </Modal>


                    {enableContinueButton && <div onClick={() => {
                      setIsBrowser(true)
                    }} style={{ color: "#003366", textDecoration: "underline", cursor: "pointer", margin: 20, }} className="app-subtitle">Continue
                    </div>}
                    {enableDisableButton && <div>
                      <p
                        style={{
                          fontSize: 15,
                          paddingTop: 10,
                          fontWeight: 800,
                          textAlign: "center",
                          color: "#F75D59",
                        }}
                      >
                        <div>For Android:</div>
                        <div>Please click</div>
                        <div>
                          {`more options (three dots) --> settings --> site settings --> enable camera, microphone & location permissions`}
                        </div>
                        <div style={{ paddingTop: 20 }}>For iOS:</div>
                        <div>Please click</div>
                        <div>
                          {`more options (`}
                          <span style={{ fontSize: 10 }}> A</span>A
                          {`)--> Website Settings --> enable camera, microphone & location permissions`}
                        </div>
                      </p>
                    </div>
                    }
                  </div>
                  }
                  {isBrowser && (<>
                    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4 relative">
                      {/* Timer in top right corner */}
                      <div className="absolute top-4 right-4 text-black  bg-blue-600 px-4 py-2 rounded-full shadow-lg text-lg font-semibold">
                        {timer}s
                      </div>
                      <div className="space-y-6 max-w-xl w-full">
                        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-300">
                          <h2 className="text-lg font-semibold text-blue-900 mb-4">
                            During Virtual Visit we will be verifying following things –
                          </h2>
                          <ol className="list-decimal list-inside text-blue-900 space-y-2 font-medium">
                            <li>Elevation of Property</li>
                            <li>Name Board/Address</li>
                            <li>Interiors</li>
                            <li>Please click share screen prior starting the measurement of property</li>
                            <li>For measurement, always point to the floor corners to fix corner points</li>
                          </ol>
                        </div>

                        <div className="bg-red-600 text-black rounded-2xl shadow-md p-4 text-center font-semibold">
                          Please do not leave this page, or access any other app, else you will be logged out of the virtual call.
                        </div>
                      </div>
                    </div>
                  </>)
                  }
                </>
              )}
            </div>
          </React.Fragment>) : (
          <React.Fragment>
            <div className="sub-home-container">
              <p className="title-text">
                Verify the URL to check for valid login credentials.
              </p>
            </div>
          </React.Fragment>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  isFetchingSesson: state.sessonLogin.isFetchingSesson,
  callDataValue: state.azureCalling.callDataValue,
  status: state.login.status,
  message: state.login.message,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCallDetails: getCallDetails,
      loginUser: loginUser,
      loginRapidUser: loginRapidUser,
      sessonLoginUser: sessonLoginUser,
      loginEncUser: loginEncUser,
      updateLocation: updateLocation,
      getCustomerAddress: getCustomerAddress,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RapidWeb);